module.exports = __webpack_public_path__ + "img/367.50ad7534.jpg";